import React, { useEffect, useState } from 'react';
import { chakra, HTMLChakraProps } from '@chakra-ui/react';
import { useTheme } from 'next-themes';

export const Logo = (props: HTMLChakraProps<'svg'>) => {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // This effect ensures we only render with the correct theme after mounting
  useEffect(() => {
    setMounted(true);
  }, []);

  // Use the current theme if mounted, otherwise use a default
  // This prevents hydration mismatch
  const currentTheme = mounted ? resolvedTheme : 'light';

  const ezColor = currentTheme === 'light' ? '#0C0042' : 'white';
  const firstLetterColor = '#FE504F';

  return (
    <chakra.svg
      color='accent'
      height={10}
      width='auto'
      viewBox='0 0 875.43 508.26'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g>
        <path
          fill={firstLetterColor}
          d='M346.23,307.05c0.71-5.13,1.06-10.37,1.04-15.7c-0.24-60.18-48.31-108.96-107.35-108.96
    c-59.04,0-106.71,48.78-106.47,108.96c0.03,8.35-1.45,42.83,28.7,75.79c30.34,33.17,67.37,33.17,78.65,33.17
    c45.64,0,84.48-29.14,99.65-70.17l-51.22,0.28c-11.5,14.5-29.09,23.77-48.85,23.77c-29.19,0-53.82-20.22-61.1-47.67l121.73,0.34
    L346.23,307.05z M180.67,268.32c8.61-24.83,31.83-42.6,59.19-42.6c27.36,0,50.72,17.77,59.54,42.6L180.67,268.32z'
        />
        <path
          fill={ezColor}
          d='M509.83,307.05c0.71-5.13,1.06-10.37,1.04-15.7c-0.24-60.18-48.31-108.96-107.35-108.96
    c-59.04,0-106.71,48.78-106.47,108.96c0.03,8.35-1.45,42.83,28.7,75.79c30.34,33.17,67.37,33.17,78.65,33.17
    c45.64,0,84.48-29.14,99.65-70.17l-51.22,0.28c-11.5,14.5-29.09,23.77-48.85,23.77c-29.19,0-53.82-20.22-61.1-47.67l121.73,0.34
    L509.83,307.05z M344.27,268.32c8.61-24.83,31.83-42.6,59.19-42.6c27.36,0,50.72,17.77,59.54,42.6L344.27,268.32z'
        />
        <g>
          <rect x='668.2' y='189.61' fill={ezColor} width='49.05' height='205.5' />
          <path
            fill={firstLetterColor}
            d='M693.33,107.96c16.75,0,29.91,13.16,29.91,29.91c0,17.95-13.16,31.11-29.91,31.11
      c-17.95,0-31.11-13.16-31.11-31.11C662.22,121.12,675.38,107.95,693.33,107.96z'
          />
        </g>
        {/* Z */}
        <polygon
          fill={ezColor}
          points='510.41,394.19 510.41,349.51 602.07,232.64 517.28,232.64 517.28,189.1 652.48,189.1
    652.48,240.66 567.69,348.36 658.2,348.36 658.2,394.19 	'
        />
        <path
          fill={firstLetterColor}
          d='M340.45,330.14l-39.4,0.22c4.35,8.81,13.04,25.66,17.93,35.13C328.22,355.32,335.57,343.35,340.45,330.14z'
        />
      </g>
    </chakra.svg>
  );
};
